import React from 'react';
import './index.scss';
import { Layout } from 'antd';
import {  FooterView } from '../Components';
import map from '../../assets/homeImages/map.jpg'

const { Content } = Layout;

const Contact = () => {
  return (
    <Layout className="layout">
      <div className="layout-header"></div>
      <Content className="about_main">
        {/* <ApplyForm /> */}

        <div className="ContactUs">
          <div className="title-weight" style={{ marginBottom: 50 }}>
            {/* <div className="title-ch">联系我们</div>
            <div className="title-en">CONTACT US</div> */}
            {/* <div className="horizontal-line" /> */}
          </div>
          <div className="ContactUs-bottom">
            <div className="seek-advice-from">
              <div className="advice-ding"></div>
              <div className="eighty-five">
                <p>产品咨询</p>
                <p>产品演示、产品试用、产品报价</p>
              </div>
              <div className="contact">
                <a style={{ color: '#fff' }} href="tel:022-6059-7296">
                  <span>座机号 ：（022）6059 7296</span>
                </a>
                <span>手机号 ： 182-2205-9108</span>
              </div>
            </div>

            <div className="cooperate">
              <div className="cooperate-ding"></div>
              <div className="eighty-five" style={{ marginBottom: 17 }}>
                <p>市场合作</p>
                <p>市场合作、生态合作</p>
              </div>
              <div className="contact">
                <span>邮&emsp;箱 ： sales@zhiyunshuke.com</span>
                <a style={{ color: '#fff' }} href="tel:022-6059-7296">
                    <span>座机号 ：（022）6059 7296</span>
                </a>
                <span>手机号 ： 182-2205-9108</span>
              </div>
            </div>
          </div>
        </div>
        <div className="certificate">
          <div className="map">
            {/*<BaiduMap></BaiduMap>*/}
            <img
              src={map}
              alt=""
              style={{height: '100%', width: '100%',objectFit: 'cover'}}
            />
          </div>
        </div>
      </Content>
      <FooterView></FooterView>
    </Layout>
  );
};

export default Contact;
